import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';

function FeatureCard({ icon, badge, title, description, benefits, index }) {
  return (
    <motion.div
      className="feature-card-wrapper"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.1 }}
    >
      <div className="feature-card-premium">
        <div className="feature-card-premium__icon">
          {icon}
        </div>

        {badge && (
          <div className="feature-card-premium__badge">
            <span>⭐</span> {badge}
          </div>
        )}

        <h3 className="feature-card-premium__title">{title}</h3>

        <p className="feature-card-premium__desc">{description}</p>

        <ul className="feature-card-premium__benefits">
          {benefits.map((benefit, i) => (
            <li key={i} className="feature-card-premium__benefit">
              <Check size={14} />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>

        <button className="feature-card-premium__btn" onClick={() => window.open('https://app.tradiora.id', '_blank')}>
          Pelajari Lebih Lanjut <ArrowRight size={14} />
        </button>
      </div>
    </motion.div>
  );
}

export default FeatureCard;
